import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoCard from "@/components/VideoCard";

export default function Rail({ title, videos, testId }) {
  const ref = useRef(null);
  if (!videos || videos.length === 0) return null;

  const scroll = (dir) => {
    if (ref.current) ref.current.scrollBy({ left: dir * 560, behavior: "smooth" });
  };

  return (
    <section className="group/rail relative py-5" data-testid={testId}>
      <div className="mb-3 flex items-center justify-between px-6 md:px-12">
        <h2 className="font-heading text-lg font-semibold tracking-tight text-foreground md:text-xl">
          {title}
        </h2>
        <div className="hidden gap-2 md:flex">
          <button
            onClick={() => scroll(-1)}
            className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition-colors hover:bg-white/15 hover:text-white"
            aria-label="prev"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button
            onClick={() => scroll(1)}
            className="flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-white/70 transition-colors hover:bg-white/15 hover:text-white"
            aria-label="next"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>
      <div
        ref={ref}
        className="no-scrollbar rail-mask flex gap-4 overflow-x-auto scroll-smooth px-6 pb-2 pt-1 md:px-12"
      >
        {videos.map((v) => (
          <VideoCard key={v.id} video={v} />
        ))}
      </div>
    </section>
  );
}
